var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifBellFilledWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 18C2.65342 18 2.33156 17.8205 2.14935 17.5257C1.96714 17.2309 1.95058 16.8628 2.10557 16.5528L4 12.7639V10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10V12.7639L21.8944 16.5528C22.0494 16.8628 22.0329 17.2309 21.8507 17.5257C21.6684 17.8205 21.3466 18 21 18H3Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C10.1362 22 8.57005 20.7252 8.12601 19H15.874C15.4299 20.7252 13.8638 22 12 22Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifBellFilledWhite);
export default __webpack_public_path__ + "static/media/notif-bell-filled-white.203f9dea6fabf82c600b052d4d5f1592.svg";
export { ForwardRef as ReactComponent };